<template>
  <v-main>
    <PageWrapper class="pa-0">
      <PageContent>
        <div class="pa-8">
          <h3 class="pb-8">Balanço</h3>
          <v-row>
            <v-col
              class="d-flex"
              cols="9"
              sm="9"
              md="9"
            >
              <v-select
                v-model="filter.idObra"
                :items="getAllObrasCustom"
                :item-text="'nome'"
                :disabled="disabledObra"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-center pb-8">
              <v-btn
                color="#27997c"
                dark
                class="mb-2"
                @click="searchByFilter"
              >
              <v-icon>mdi-magnify</v-icon>
                Pesquisar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex flex-row">
              <v-text-field
                v-model="filter.dataInicio"
                v-mask="'##/##/####'"
                label="Data de início"
                :rules="[
                  dateRules.isValidDate,
                  dateRules.isNotFutureDate
                ]"
                outlined
                class="pr-2"
              ></v-text-field>
              <v-text-field
                v-model="filter.dataFinal"
                v-mask="'##/##/####'"
                label="Data de fim"
                :rules="[
                  dateRules.isValidDate,
                  dateRules.isNotFutureDate
                ]"
                outlined
                class="pl-2"
              ></v-text-field>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="4" class="d-flex flex-row">
              <v-text-field
                v-model="filter.dataInicioEntrada"
                v-mask="'##/##/####'"
                label="Data de início"
                :rules="[
                  dateRules.isValidDate,
                  dateRules.isNotFutureDate
                ]"
                outlined
                class="pr-2"
              ></v-text-field>
              <v-text-field
                v-model="filter.dataFimEntrada"
                v-mask="'##/##/####'"
                label="Data de fim"
                :rules="[
                  dateRules.isValidDate,
                  dateRules.isNotFutureDate
                ]"
                outlined
                class="pl-2"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              Balanço Atual : {{ (totalEntrada - totalSaida) | localCurrency }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6"><span class="red--text">Total Saída: {{ totalSaida | localCurrency}}</span></v-col>
            <v-col cols="6"><span class="green--text text--darken-4">Total Entrada: {{ totalEntrada | localCurrency}}</span></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="ml-0 pl-0">
              <download-excel :data="getListCustomSaidaExcel" :fields="forExcelSaida" style="width: 200px">
                <v-btn
                  class="green darken-1 mx-0 ml-sm-2"
                  :disabled="getListCustomSaida.length == 0"
                >
                  <v-icon
                    color="white"
                    right
                    dark
                  >
                    mdi-file-excel
                  </v-icon>
                  <span class="white--text px-5">EXCEL Saída</span>
                </v-btn>
              </download-excel>
            </v-col>
            <v-col cols="6" class="ml-0 pl-0">
              <download-excel :data="getListCustomEntradaExcel" :fields="forExcelEntrada" style="width: 200px">
                <v-btn
                  class="green darken-1 mx-0 ml-sm-2"
                  :disabled="getListCustomEntrada.length == 0"
                >
                  <v-icon
                    color="white"
                    right
                    dark
                  >
                    mdi-file-excel
                  </v-icon>
                  <span class="white--text px-5">EXCEL Entrada</span>
                </v-btn>
              </download-excel>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Valores
                      </th>
                      <th class="text-left">
                        Data de saída
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in getListCustomSaida"
                      :key="item.id"
                    >
                      <td colspan="2" class="pa-0">
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <v-row>
                                <v-col cols="6">
                                  {{ item.valor | localCurrency }}
                                </v-col>
                                <v-col cols="6">
                                  {{ item.data_saida }}
                                </v-col>
                              </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col cols="6">Obra:</v-col>
                                <v-col cols="6">{{ item.obra ? item.obra.descricao : '' }}</v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6">Pessoa / Empresa:</v-col>
                                <v-col cols="6">{{ item.nome }}</v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6">Descrição:</v-col>
                                <v-col cols="6">{{ item.descricao || item.pessoaManual }}</v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Valores
                      </th>
                      <th class="text-left">
                        Data de entrada
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in getListCustomEntrada"
                      :key="item.id"
                    >
                      <td>{{ item.valor | localCurrency }}</td>
                      <td>{{ item.data_entrada }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </div>
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
import { mapGetters, mapActions } from 'vuex';
import{dateRules} from '@/validations';
import user from '@/utils/user.json';

export default {
  components:{
    PageWrapper,
    PageContent,
  },
  data: () => ({
    obras: [],
    detail: 0,
    filter:{
      idObra: null,
      dataInicio: null,
      dataFinal: null,
      dataInicioEntrada: null,
      dataFimEntrada: null
    },
    disabledObra: false,
    user,
    listSaida: [],
    listEntrada: [],
    dateRules,
    headersExcel: [
      {
        text: 'Empresas /Pessoa',
        align: 'start',
        sortable: false,
        value: 'nome',
      },
      { text: 'Descrição', value: 'descricao',  sortable: false,  align: 'start', },
      { text: 'Data de entrada', value: 'data_entrada',  sortable: false,  align: 'start',  },
      { text: 'NFE', value: 'nfe',  sortable: false,  align: 'start',  },
      { text: 'Valor', value: 'valor',  sortable: false,  align: 'start',  },
      { text: 'Ações', value: 'actions', sortable: false, align: 'start',  },
    ],
    headersExcelSaida: [
      {
        text: 'Empresas /Pessoa',
        align: 'center',
        sortable: false,
        value: 'nome',
      },
      {
        text: 'Descrição Manual',
        align: 'center',
        sortable: false,
        value: 'pessoaManual',
      },
      { text: 'Obras', value: 'obra.nome',  sortable: false,  align: 'center',  },
      { text: 'NFE', value: 'nfe',  sortable: false,  align: 'center',  },
      { text: 'Data de saída', value: 'data_saida',  sortable: false,  align: 'center',  },
      { text: 'Valor', value: 'valor',  sortable: false,  align: 'center',  },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center',  },
    ],
    

  }),

  computed: {
    ...mapGetters('obra', {getObras:'getList'}),
    getAllObrasCustom(){
      const email = localStorage.getItem("email_logged");
      const userLogged = user.find((item)=> item.email == email);
      if(userLogged.obras && this.filter){
        this.disabledObra = true;
        this.filter.idObra = userLogged.obras[0];
        return this.getObras.filter((item)=>{
          const obrasPermitidas = userLogged.obras;
          return obrasPermitidas.find((itemId)=> item.id === itemId)
        });
      }

      return this.getObras;
    },
    totalEntrada(){
      return this.getListCustomEntrada.map((item) => Number(item.valor)).reduce((partialSum, a) => partialSum + a, 0)
    },
    totalSaida(){
      return this.getListCustomSaida.map((item) => Number(item.valor)).reduce((partialSum, a) => partialSum + a, 0)
    },
    getListCustomSaidaExcel(){
      const list = Object.assign([], this.listSaida.map((item )=>{
        return {
          ...item,
          nome: (item.pessoa && item.pessoa.nome) || (item.empresa && item.empresa.nome),
          valor: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor),
          pessoaManual: (item.pessoaManual || item.descricao),
          dataSaidaObj: this.transformDateFormat(item.data_saida)
        }
      }));
      let listOrdered = list.sort(function(a,b){
        return b.dataSaidaObj - a.dataSaidaObj;
      });
      if(this.filter.dataInicio && this.filter.dataInicio != '' && this.filter.dataInicio.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataSaidaObj).getTime() >= new Date(this.transformDateFormat(this.filter.dataInicio)).getTime()
        })
      }

      if(this.filter.dataFinal && this.filter.dataFinal != '' && this.filter.dataFinal.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataSaidaObj).getTime() <= new Date(this.transformDateFormat(this.filter.dataFinal)).getTime()
        })
      }
      listOrdered.push({});
      listOrdered.push({data_saida: 'Somatório', valor: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.totalSaida)})
      return listOrdered
    },
    getListCustomSaida(){
      const list = Object.assign([], this.listSaida.map((item )=>{
        return {
          ...item,
          nome: (item.pessoa && item.pessoa.nome) || (item.empresa && item.empresa.nome),
          pessoaManual: (item.pessoaManual || item.descricao),
          dataSaidaObj: this.transformDateFormat(item.data_saida)
        }
      }));
      let listOrdered = list.sort(function(a,b){
        return b.dataSaidaObj - a.dataSaidaObj;
      });
      if(this.filter.dataInicio && this.filter.dataInicio != '' && this.filter.dataInicio.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataSaidaObj).getTime() >= new Date(this.transformDateFormat(this.filter.dataInicio)).getTime()
        })
      }

      if(this.filter.dataFinal && this.filter.dataFinal != '' && this.filter.dataFinal.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataSaidaObj).getTime() <= new Date(this.transformDateFormat(this.filter.dataFinal)).getTime()
        })
      }
      return listOrdered
    },
    getListCustomEntradaExcel(){
      const list = Object.assign([], this.listEntrada.map((item )=>{
        return {
          ...item,
          nome: (item.pessoa && item.pessoa.nome) || (item.empresa && item.empresa.nome),
          valor: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor),
          dataEntradaObj: this.transformDateFormat(item.data_entrada)
        }
      }));
      let listOrdered = list.sort(function(a,b){
        return b.dataEntradaObj - a.dataEntradaObj;
      });
      if(this.filter.dataInicioEntrada && this.filter.dataInicioEntrada != '' && this.filter.dataInicioEntrada.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataEntradaObj).getTime() >= new Date(this.transformDateFormat(this.filter.dataInicioEntrada)).getTime()
        })
      }

      if(this.filter.dataFimEntrada && this.filter.dataFimEntrada != '' && this.filter.dataFimEntrada.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataEntradaObj).getTime() <= new Date(this.transformDateFormat(this.filter.dataFimEntrada)).getTime()
        })
      }

      listOrdered.push({});
      listOrdered.push({data_entrada: 'Somatório', valor: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.totalEntrada)})
      return listOrdered
    },
    getListCustomEntrada(){
      const list = Object.assign([], this.listEntrada.map((item )=>{
        return {
          ...item,
          nome: (item.pessoa && item.pessoa.nome) || (item.empresa && item.empresa.nome),
          dataEntradaObj: this.transformDateFormat(item.data_entrada)
        }
      }));
      let listOrdered = list.sort(function(a,b){
        return b.dataEntradaObj - a.dataEntradaObj;
      });
      if(this.filter.dataInicioEntrada && this.filter.dataInicioEntrada != '' && this.filter.dataInicioEntrada.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataEntradaObj).getTime() >= new Date(this.transformDateFormat(this.filter.dataInicioEntrada)).getTime()
        })
      }

      if(this.filter.dataFimEntrada && this.filter.dataFimEntrada != '' && this.filter.dataFimEntrada.length > 9){
        listOrdered = listOrdered.filter((item)=>{
          return new Date(item.dataEntradaObj).getTime() <= new Date(this.transformDateFormat(this.filter.dataFimEntrada)).getTime()
        })
      }

      return listOrdered
    },
    forExcelEntrada(){
      let jsonFilter = {};
      this.headersExcel.forEach(element => {
        jsonFilter[element.text] = element.value
      });
      return jsonFilter;
    },
    forExcelSaida(){
      let jsonFilter = {};
      this.headersExcelSaida.forEach(element => {
        jsonFilter[element.text] = element.value
      });
      return jsonFilter;
    },
  },
  async mounted(){
    await this.getAllObras()
  },

  methods: {
    ...mapActions('obra', {getAllObras:'getAllObras'}),
    ...mapActions('saida', {getBalancoBySaida:'getBalancoBySaida'}),
    ...mapActions('entrada', {getBalancoByEntrada:'getBalancoByEntrada'}),
    async searchByFilter(){
      this.listSaida = await this.getBalancoBySaida(this.filter)
      this.listEntrada = await this.getBalancoByEntrada(this.filter)
    },
    transformDateFormat(dateString) {
      var dateParts = dateString.split("/");
      return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    },
  },
}
</script>

<style>
</style>
